import { Component, effect, OnInit, Signal } from '@angular/core';
import { SidebarService } from '@services/sidebar/sidebar.service';
import { TranslateModule } from '@ngx-translate/core';
import { MixpanelService } from '@services/mixpanel/mixpanel.service';
import { AuthService } from '@services/auth/auth.service';
import { RouterLink } from '@angular/router';
import { FeatureService } from '@services/feature-toggle/feature.service';
import { AuthenticatedUser, DashboardOwnerUser } from '@dashboard_models/dashboard-owner-user';
import { HelperService } from '@services/helper/helper.service';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { AwTooltipComponent } from '@components/misc/aw-tooltip/aw-tooltip.component';
import { FormsModule } from '@angular/forms';
import { OwnerSelectorComponent } from './owner-selector/owner-selector.component';
import { SamlService } from '@services/auth/saml.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-sidebar',
    imports: [TranslateModule, RouterLink, AwTooltipComponent, FormsModule, OwnerSelectorComponent],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
    dashboardOwnerUser: DashboardOwnerUser = this.helperService.getDashboardOwnerUser();
    authenticatedUser: AuthenticatedUser = this.localStorageService.getItem('authenticatedUser');

    isDemo: boolean = environment.isDemo;

    isActionsEnabled = this.featureService.getFeatureAccess('actions', 'route_access');
    isOperatorDevicesEnabled = this.featureService.getFeatureAccess('operator_devices', 'route_access');
    isOperatorHealthMonitorEnabled = this.featureService.getFeatureAccess('operator_health_monitor', 'route_access');

    constructor(
        protected sidebarService: SidebarService,
        private mixpanelService: MixpanelService,
        protected authService: AuthService,
        protected featureService: FeatureService,
        private helperService: HelperService,
        protected samlService: SamlService,
        private localStorageService: LocalStorageService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.samlService.setupSamlService();
    }

    signOut() {
        this.mixpanelService.track('Action: Log Out Click', { action: 'log out was clicked' });
        this.authService.signOut();
    }
}
